<template>
    <div>
        <Dialog title="Organization Members" :show="isOpen" :onClose="onCancel">
            <div class="container">
                <Table :items="members" :columns="columns" :loading="loading" :links="links" :actions="actions" />
            </div>
            <el-divider></el-divider>
            <el-row type="flex" justify="center">
                <el-button type="primary" size="small" @click="onCancel">OK</el-button>
            </el-row>
        </Dialog>

        <EditDialog v-if="showEditDialog" :item="editItem" :isOpen="showEditDialog" :onCancel="onCancelEditMember"
            :onSave="onSaveEditMember" />
    </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from "vue";
import Dialog from "@/components/Dialog";
import Table from "@/components/Table";
import EditDialog from "./EditOrgMember";
import { useStore } from "@/store";
import { useNotify } from "@/utils/notify";

export default defineComponent({
    name: "OrgMembers",
    components: {
        Dialog,
        Table,
        EditDialog,
    },
    props: {
        org: Object,
        isOpen: Boolean,
        onCancel: Function,
    },
    setup(props) {
        const { dispatch } = useStore();
        const { success, error } = useNotify();

        const loading = ref(false);
        const members = ref([]);
        const showEditDialog = ref(false);
        const editItem = ref({});

        const edit = (item) => {
            editItem.value = item;
            showEditDialog.value = true;
        };

        const onCancelEditMember = () => {
            editItem.value = {};
            showEditDialog.value = false;
        };

        const onSaveEditMember = async (item) => {
            editItem.value = {};
            loading.value = true;
            showEditDialog.value = false;
            try {
                await dispatch("enterprise/updateOrgMember", { id: props.org.id, payload: { id: item.user_id, access_level: item.access_level } });
                success("Organization member updated successfully");
            } catch (e) {
                error("Failed to update organization member");
            }
            loading.value = false;
        };

        const fetchMembers = async () => {
            loading.value = true;
            const ids = props.org.members.map((m) => m.user_id);
            try {
                const result = await dispatch("getUsers", { ids });
                members.value = props.org.members.map((m) => {
                    const user = result.find((u) => u.id === m.user_id);
                    return { ...m, email: user.email };
                });
            } catch (e) {
                error("Failed to fetch organization members");
            }

            loading.value = false;
        };

        onMounted(() => {
            if (props.isOpen) {
                fetchMembers();
            }
        });


        const columns = [
            { label: "Email", prop: "email" },
            { label: "Access Level", prop: "access_level" },
        ];

        const links = [
            {
                label: "View user",
                to: (item) => `/customers/user/${item.user_id}`,
            },
        ];

        const actions = [
            { name: "Edit", type: "default", onClick: edit },
        ];

        return {
            columns,
            links,
            actions,
            loading,
            members,
            showEditDialog,
            editItem,
            edit,
            onCancelEditMember,
            onSaveEditMember,
        };
    },
});
</script>

<style scoped>
.container>*+* {
    margin-top: 10px;
}
</style>